
namespace TabAurous.Master {

    @Serenity.Decorators.registerClass()
    export class EmployeeDetailsDialog extends Serenity.EntityDialog<EmployeeDetailsRow, any> {
        protected getFormKey() { return EmployeeDetailsForm.formKey; }
        protected getIdProperty() { return EmployeeDetailsRow.idProperty; }
        protected getLocalTextPrefix() { return EmployeeDetailsRow.localTextPrefix; }
        protected getService() { return EmployeeDetailsService.baseUrl; }
        protected getDeletePermission() { return EmployeeDetailsRow.deletePermission; }
        protected getInsertPermission() { return EmployeeDetailsRow.insertPermission; }
        protected getUpdatePermission() { return EmployeeDetailsRow.updatePermission; }

        protected form = new EmployeeDetailsForm(this.idPrefix);

    }
}